import { render } from "./CartShopIcon01.vue?vue&type=template&id=c180c45e&scoped=true"
import script from "./CartShopIcon01.vue?vue&type=script&lang=js"
export * from "./CartShopIcon01.vue?vue&type=script&lang=js"

import "./CartShopIcon01.vue?vue&type=style&index=0&id=c180c45e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c180c45e"]])

export default __exports__